import React, { useState, useRef, useEffect } from "react";
import "jspdf-autotable";
import './SeeLogActivity.css';
import { toast } from "react-toastify";
import AdminTable from "../../../components/CommonComponents/AdminTable";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight } from "react-icons/md";
import NoRecordTable from "../../../components/CommonComponents/NoRecordTable";
import { RxReload } from "react-icons/rx";
import ExportIcon from "../../../components/Images/icons/Export_Icon_01.png";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import useTablePage from "../../../components/CommonComponents/useTablePage";
import { donwloadCSV, videodownloadPDF, videodownloadXLSX } from "../../../components/CommonMethod/CommonMethods";
import Defaultloadinggif from "../../../layout/Others/Defaultloadinggif";

function SeeLogActivity() {
  const access_token = localStorage.getItem("access_token");

  const { fetchRequest } = useMyContext()
  const [loading, setLoading] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [logActivityData, setLogActivityData] = useState([]);
  const [filteredlogactivityData, setFilteredlogactivityData] = useState([]);
  const [total, setTotal] = useState('');
  const { page, limit, handlePageChange, handleSizePerPageChange } = useTablePage(10);
  const [filteredData, setFilteredData] = useState([]);
  const [reloading, setReLoading] = useState(false);
  const [formData, setFormData] = useState({
    state: "formData",
    view_type: "list",
    view_type_option: [{
      name: "List",
      value: "list"
    },
    {
      name: "Gallery",
      value: "grid"
    }]
  })

  const fetchLogActivityData = async (type) => {
    setLoading(true);
    try {
      const response = await fetchRequest({
        method: "GET",
        url: `${process.env.REACT_APP_Baseurl}/admin/LogActivity/index`,
        params: { limit, page },
        data: {},
      });

      if (response?.status) {
        const data = response?.data || [];
        setLogActivityData(data);
        setFilteredlogactivityData(data);
        setFilteredData(data);
        setTotal(response?.pagination);

        const exportData = data.map((item, index) => ({
          "S.NO": index + 1,
          "ACTION": item?.action,
          "USER AGENT": item?.agent,
          "SUBJECT": item?.subject,
          "TYPE": item?.source_type_name,
        }));

        if (type === "CSV") {
          await donwloadCSV(exportData, "LOG-ACTIVITY-LIST");
        } else if (type === "PDF") {
          await videodownloadPDF(exportData, "LOG-ACTIVITY-LIST", [
            "S.NO", "ACTION", "USER AGENT", "SUBJECT", "TYPE"
          ]);
        } else if (type === "XLSX") {
          await videodownloadXLSX(exportData, "LOG-ACTIVITY-LIST", [
            "S.NO", "ACTION", "USER AGENT", "SUBJECT", "TYPE"
          ]);
        }

        toast.success(response?.message);
      } else {
        toast.error(response?.message || "Something went wrong");
      }

    } catch (error) {
      toast.error(error?.message || "Error fetching data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogActivityData();
  }, [page, limit]);

  const columns = [
    {
      dateField: "User Agent",
      text: "User Agent",
      formatter: (cell, row) => {
        return <div className="text" style={{ maxWidth: "200px" }}>
          {row?.agent}
        </div>;
      },
    },
    {
      dataField: "Subject",
      text: "Subject",
      formatter: (cell, row) => {
        return <div className="text" style={{ maxWidth: "250px" }}>
          {row?.subject}
        </div>;
      },
    },
    {
      dataField: "Source_Type",
      text: "Type",
      formatter: (cell, row) => {
        return <div className="text" style={{ maxWidth: "200px" }}>
          {row?.source_type_name}
        </div>;
      },
    },
    {
      dataField: "Action",
      text: "Action",
      formatter: (cell, row) => {
        return <div className="text" style={{ maxWidth: "200px" }}>
          {row?.action}
        </div>;
      },
    },
    {
      dataField: "createdAt",
      text: "Created At",
      formatter: (cell, row) => {
        const dateObj = row?.createdAt ? new Date(row.createdAt) : null;
        const formattedDate = dateObj
          ? dateObj.toLocaleDateString("en-US")
          : "-";
        const formattedTime = dateObj
          ? dateObj.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })
          : "";

        return (
          <div className="d-flex justify-content-start align-items-center" style={{ maxWidth: "200px" }}>
            <p className="mb-0">{formattedDate} {formattedTime}</p>
          </div>
        );
      }
    }
  ]

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();

    if (!value) {
      setFilteredData(logActivityData);
      return;
    }

    const filtered = logActivityData.filter(item =>
      item.action?.toLowerCase().includes(value) ||
      item.agent?.toLowerCase().includes(value) ||
      item.subject?.toLowerCase().includes(value) ||
      item.source_type_name?.toLowerCase().includes(value)
    );
    setFilteredData(filtered);
  };

  const reloadAction = async () => {
    setReLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    // try {
    //   const response = await axios.get(listApi, {
    //     headers: headers,
    //   });

    // } catch (error) {
    //   console.error("Error fetching data:", error);
    // } finally {
    setReLoading(false);
    // }
  };

  const options = {
    pageStartIndex: 1,
    paginationSize: 3,
    sizePerPage: 10,
  };


  const handleSort = (field) => {
    const sortedData = [...logActivityData].sort((a, b) => {
      if (a[field] < b[field]) return -1;
      if (a[field] > b[field]) return 1;
      return 0;
    });
    setLogActivityData(sortedData);
  };

  return (

    <div className=" m-0 p-0">
      {reloading && (
        <div style={{
          position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255,255,255,0.6)',
          display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 10,
        }}><Defaultloadinggif />
        </div>
      )}

      <div className="theme-bg-color p-3 rounded-2 bootstrapTable" >
        <AdminNavbar heading={"Log Activities"} totalDataLength={filteredData?.length} />
        <div className='theme-bg-color p-3 rounded-3 mb-5'>
          <div className='d-flex align-items-center flex-wrap justify-content-between  mb-3'>
            <div className="filterContainer">
              <input type='text' placeholder="Search" className="filter form-control theme-text-color theme-border-secondary theme-bg-color-secondary" onChange={handleSearch} />
            </div>

            <div className=' d-flex align-items-center'>

              <button className={`bg-transparent reloadButton theme-text-color p-2 me-2 primary border border-2 rounded-circle theme-border-color ${loading ? "rotate-load" : ""}`} onClick={reloadAction}>
                <RxReload style={{ width: "18px", height: "15px" }} />
              </button>

              <div className="dropdown d-block ms-2 " key={"2"}>
                <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"  >
                  <span className="fw-bolder text-white">Export all</span>
                  <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
                </button>
                <ul className="dropdown-menu theme-bg-color" aria-labelledby="dropdownMenuButton1" >
                  <li className="dropdown-item theme-text-color cursor-pointer" onClick={() => fetchLogActivityData("CSV", "ALL")}>CSV</li>
                  <li className="dropdown-item theme-text-color cursor-pointer" onClick={() => fetchLogActivityData("PDF", "ALL")}>PDF</li>
                  <li className="dropdown-item theme-text-color cursor-pointer" onClick={() => fetchLogActivityData("XLSX", "ALL")}>XLSX </li>
                </ul>
              </div>

            </div>
          </div>

          <AdminTable
            data={filteredData}
            loading={loading}
            options={options}
            handlePageChange={handlePageChange}
            page={page}
            pagination={total}
            handleSizePerPageChange={handleSizePerPageChange}
            columns={columns}
            limit={limit}
            onSort={handleSort}
            viewType={formData?.view_type}
            className="no-border-table theme-text-color "
          />
          {/* <BootstrapTable keyField="id" pagination={pagination} columns={columns} data={filteredData} className="no-border-table theme-text-color " noDataIndication={<NoRecordTable result={filteredData?.length} loader={loading} />} hover headerClasses="videoWidth" /> */}
        </div>
      </div>
    </div>
  );
};

export default SeeLogActivity;